import { render, staticRenderFns } from "./ClientsDiscovery.vue?vue&type=template&id=075b2874&scoped=true"
import script from "./ClientsDiscovery.vue?vue&type=script&lang=js"
export * from "./ClientsDiscovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075b2874",
  null
  
)

export default component.exports